import React, { Component } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LinearProgress from '@mui/material/LinearProgress';
import DomainsApi from '../../api/domains';
import { connect } from 'react-redux';
import { showError, showMessage } from '../../actions/uiActions';
import WysiwygEditor from '../../components/WysiwygEditor';
class DomainString extends Component {
  state = {
    string_id: '',
    string_text: '',
    busy: false,
    strings: {}
  };
  componentDidMount() {
    this.setState({ strings: { ...(this.props.domain.strings || {}) } });
  }
  handleInputChange = e => {
    this.setState({ [e.target.name]: e.target.value, string_text: '' });
  };
  setStringText = e => {
    if (!this.state.string_id) this.setState({ string_text: e.target.value });
    else
      this.setState({
        strings: {
          ...this.state.strings,
          [this.state.string_id]: e.target.value
        }
      });
  };
  save = () => {
    if (this.state.string_id === '')
      this.props.showError(
        'Please select the ID of the text you want to change.'
      );
    else
      this.setState({ busy: true }, () =>
        DomainsApi.setString(
          this.props.domain._id,
          this.state.string_id,
          this.state.strings[this.state.string_id]
        )
          .then(
            form => {
              this.props.showMessage('The text has been updated.');
              this.props.onStringUpdated(
                this.state.string_id,
                this.state.strings[this.state.string_id]
              );
              this.props.onCancel();
            },
            error => this.setState({ busy: false }, this.props.showError)
          )
          .catch(error => error =>
            this.setState({ busy: false }, this.props.showError)
          )
      );
  };
  render() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth="md"
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        open={true}
      >
        <DialogTitle id="alert-dialog-title">
          Customize Domain Texts
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Use the form below to customize the texts displayed to the users of
            this domain on the ED Lead gen tool.
          </DialogContentText>
          <div className="form-group nice">
            <label>Text ID:</label>
            <select
              name="string_id"
              onChange={this.handleInputChange}
              value={this.state.string_id}
              disabled={this.state.busy}
              className="form-control"
            >
              <option value="">Select...</option>
              <option value="authentication_error">
                Invalid Email or Code Error
              </option>
              <option value="thank_you">Thank You message</option>
              <option value="auth_code_info">Authorization Code Info</option>
              <option value="landing_page_info">Landing Page Info</option>
              <option value="lendkey_url">LendKey URL</option>
            </select>
          </div>

          <div className="form-group nice">
            <WysiwygEditor
              className="form-control"
              name="string_text"
              onChange={this.setStringText}
              disabled={this.state.busy}
              value={
                !this.state.string_id ||
                !this.state.strings.hasOwnProperty(this.state.string_id)
                  ? this.state.string_text
                  : this.state.strings[this.state.string_id]
              }
            />
          </div>

          {this.state.busy && <LinearProgress />}
        </DialogContent>
        {!this.state.busy && (
          <DialogActions>
            <Button
              variant="outlined"
              onClick={this.save}
              color="primary"
              autoFocus
            >
              Update Text
            </Button>
            <Button onClick={this.props.onCancel} color="primary">
              Cancel
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}
const mapStateToProps = state => {
  return state;
};
export default connect(mapStateToProps, { showError, showMessage })(
  DomainString
);
